import { render, staticRenderFns } from "./LexboxRedirectView.vue?vue&type=template&id=bd6c1df4&scoped=true&lang=pug"
import script from "./LexboxRedirectView.vue?vue&type=script&lang=ts"
export * from "./LexboxRedirectView.vue?vue&type=script&lang=ts"
import style0 from "./LexboxRedirectView.vue?vue&type=style&index=0&id=bd6c1df4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6c1df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd6c1df4')) {
      api.createRecord('bd6c1df4', component.options)
    } else {
      api.reload('bd6c1df4', component.options)
    }
    module.hot.accept("./LexboxRedirectView.vue?vue&type=template&id=bd6c1df4&scoped=true&lang=pug", function () {
      api.rerender('bd6c1df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Lexbox/LexboxRedirectView.vue"
export default component.exports